"use client";

import { Turnstile } from "next-turnstile";

interface TurnstileProps {
  onVerify: (token: string | null) => void;
  siteKey: string;
}

export default function AlluraTurnstile({ onVerify, siteKey }: TurnstileProps) {
  return (
    <Turnstile
      siteKey={siteKey}
      onVerify={(token) => onVerify(token)}
      onExpire={() => onVerify(null)}
      onError={() => onVerify(null)}
      theme="light"
    />
  );
}
